import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./LotStyles.css";
import LotsDetails from "../programmes/components/LotsDetails";
import ProgrammeHeader from "../programmes/components/ProgrammeHeader";
import Documents from "../programmes/components/Documents";
import Quartier from "../programmes/components/Quartier";
import ResponsableProgramme from "../programmes/components/ResponsableProgramme";
import ProgramHero from "../programmes/components/ProgramHero";
import Disponibilite from "../programmes/components/Disponibilite";
import {
  fetchSingleLot,
  fetchSingleProgram,
} from "../../../../redux/actions/immobilierActions";
import toast from "react-hot-toast";
import moment from "moment";
import { openModal } from "../../../../redux/actions/modalActions";
import EditLotModal from "../../componnents/EditLotModal";
import mainAxios from "../../../../redux/api/mainAxios";

const Lot = ({ lotData, setDisplayedLot }) => {
  const [synchLoading, setSynchLoading] = useState(false);
  const dispatch = useDispatch();
  const componentRef = useRef(null);
  const { singleProgram } = useSelector((state) => state.immobilierReducer);

  useEffect(() => {
    if (lotData?.programme_parent?.documentId) {
      dispatch(fetchSingleProgram(lotData.programme_parent.documentId, false));
    }
  }, [lotData, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleEditLot = () => {
    if (!lotData?.reference) return;
    dispatch(
      openModal({
        title: `Modifier le Lot ${lotData.reference}`,
        content: <EditLotModal lot={lotData} />,
      }),
    );
  };

  const updateLot = async (id) => {
    if (!id) return;
    setSynchLoading(true);
    try {
      const response = await mainAxios.get(
        `api/update-gridky-single-lot/${id}`,
      );

      if (response.status === 200) {
        toast.success("Synchronisation réussie");
        dispatch(fetchSingleLot(lotData.documentId));

        if (lotData?.programme_parent?.documentId) {
          dispatch(
            fetchSingleProgram(lotData.programme_parent.documentId, false),
          );
        }
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          toast.error("Lot n'est plus disponible sur Gridky");
        } else {
          toast.error("Erreur lors de la synchronisation");
        }
      } else {
        toast.error("Erreur lors de la synchronisation");
      }
      console.error(error);
    } finally {
      setSynchLoading(false);
    }
  };

  if (!lotData) {
    return <div>.....</div>;
  }

  return (
    <div className="bg-light-grey" ref={componentRef}>
      <ProgrammeHeader
        urlPromoteur={lotData?.programme_parent?.promoteur?.url}
      />
      <div className="d-flex justify-content-between align-items-center mt-20">
        <div>
          <div className="fs14 regular">
            <span>Origine du lot: </span>
            <span className="bold">
              {lotData?.api_parent?.[0]?.name || "Manuel"}
            </span>
          </div>
          <div className="fs14 regular">
            <span>Dernière synchronisation: </span>
            <span className="bold">
              {moment().diff(lotData.lastSync, "minutes") < 1
                ? "À l'instant"
                : moment(lotData.lastSync).format("DD/MM/YYYY à HH:mm")}
            </span>
          </div>
        </div>

        <div className="d-flex gap10">
          <button
            className={"radius5 px-20 py-10 bg-pink text-white border-0"}
            onClick={handleEditLot}
          >
            Modifier
          </button>
          {lotData.api_parent?.[0]?.name?.toLowerCase()?.includes("gridky") && (
            <button
              className={
                !synchLoading
                  ? "radius5 px-20 py-10 bg-pink text-white border-0"
                  : "radius5 px-20 py-10 bg-soft-grey text-white border-0 pointer-none"
              }
              onClick={() => updateLot(lotData.original_id)}
              disabled={synchLoading}
            >
              Synchroniser
            </button>
          )}
        </div>
      </div>
      <div className="position-relative">
        <LotsDetails singleLot={lotData} marginTop="22px" />
        <Documents programDocuments={lotData.documents_pdfs} />
        <Quartier
          location={[lotData.programme_parent]}
          position={{
            lng: lotData.programme_parent.longitude,
            lat: lotData.programme_parent.latitude,
          }}
        />
        <ResponsableProgramme
          program={singleProgram?.promoteur?.promoteur_accesses || []}
        />
        <div className="mt-70" id="programme">
          <p className="semibold fs16 pink">Informations Programme</p>
          <ProgramHero program={lotData.programme_parent} images={[lotData]} />
        </div>
        {singleProgram && (
          <Disponibilite
            lots={singleProgram.lots}
            setDisplayedLot={setDisplayedLot}
            openNewtab={true}
          />
        )}
      </div>
    </div>
  );
};

export default Lot;
